import React from "react";
import Modal from "react-bootstrap/Modal";
import ClientSearch from "./ClientSearch";

function ClientSearchModal({ state, show, setShow, setClient }) {
  return (
    <Modal
      show={show}
      onHide={() => {
        setShow(false);
      }}
      animation={false}
      size="xl"
      fullscreen="sm-down"
      centered
    >
      <Modal.Header closeButton className="bg-safy-info text-white">
        <Modal.Title className="fs-5">{`Client Search for ${state}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-safy2-4 p-2 p-md-3">
        <ClientSearch
          show={show}
          setShow={setShow}
          state={state}
          setClient={setClient}
        />
      </Modal.Body>
      <Modal.Footer className="bg-safy2-4">
        <button
          className="btn btn-danger"
          onClick={() => {
            setShow(false);
          }}
        >
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ClientSearchModal;
